import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.9, delay, ease: EASE }}>
      {children}
    </M>
  );
};

// Masked line-by-line reveal: text sits inside an overflow-hidden line and slides up from below.
// For scroll reveals the observer sits on the unclipped outer wrapper.
export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.15, inView = false }) => {
  const trigger = inView ? { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } } : { initial: "hidden", animate: "show" };
  return (
    <motion.span className={`block ${className}`} {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${typeof lineClass === "function" ? lineClass(i) : lineClass}`}
            variants={{ hidden: { y: "105%" }, show: { y: "0%", transition: { duration: 1.1, delay: delay + i * 0.12, ease: EASE } } }}
          >
            {l}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Stagger = ({ children, className = "" }) => (
  <motion.div className={className} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.1 }} variants={{ hidden: {}, show: { transition: { staggerChildren: 0.08 } } }}>
    {children}
  </motion.div>
);

export const Item = ({ children, className = "", ...rest }) => (
  <motion.div className={className} variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE } } }} {...rest}>
    {children}
  </motion.div>
);
